import { h } from "preact";

import Button from "./Button.jsx";
import Icon from "./Icon.jsx";
import { classNames } from "../helpers.js";

export default function CircularButton({ children, grey, ...props }) {
  return (
    <Button
      circular
      {...props}
      class={classNames(props.class, grey && "button--circular-grey")}
    >
      <Icon>{children}</Icon>
    </Button>
  );
}
